import { push } from "connected-react-router";
import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
  ROUTE_PATH,
  REQUEST_STATUS,
  ERROR_CODE,
  APPLICATION_MODE_RENEW
} from "../../../app/constants";
import { GetProviceCodeFromName, ValidateString } from "../../../app/utils";
import { CanadaProvinceList } from "../../../app/constants";
import { Header, Button, ErrorMark, Paragraph, NavigationLinkButton } from "../../../components/RegularComponents";
import { ErrorWithString } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import {
  ERROR_STRING,
  VALIDATION_TYPE,
  VALIDATION_ERROR,
  postalCodeErrorString,
} from "../../../app/errors";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import { 
  setMortgageProperty, 
} from "../../../redux/slice/primaryAgencyApplicationSlice";
import TrustAccountSigningOfficer from "../MA/TrustAccountSigningOfficer";

const MORTGAGE_APPLICATION_PROPERTY = "trustAccountInstitution";

export const RenewalTrustAccount = (props) => {

  const applicationType = APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE;
  const applicationMode = APPLICATION_MODE_RENEW;
  
  const trustData = useSelector(
    state => state.primaryAgencyApplication.application?.businessLicenceData?.trustAccountInstitution ?? {}
  )
  const serverSaveRequest = useSelector(state => state.primaryAgencyApplication.serverRequestStatus)

  const { isModal = false, onEditSave = () => {} } = props;

  const dispatch = useDispatch();
  const [applicationSaveError, setApplicationSaveError] = useState(false);
  const [financialInstitution, setFinancialInstitution] = useState(trustData?.branchName);
  const [financialInstitutionError, setFinancialInstitutionError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [branchAddress, setBranchAddress] = useState(trustData?.address?.singleLineAddress);
  const [branchAddressError, setBranchAddressError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [city, setCity] = useState(trustData?.address?.city);
  const [cityError, setCityError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [province, setProvince] = useState(trustData?.address?.province);
  const [provinceError, setProvinceError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [postalCode, setPostalCode] = useState(trustData?.address?.postalCode);
  const [postalCodeError, setPostalCodeError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [accountNumber, setAccountNumber] = useState(trustData?.accountNumber);
  const [accountNumberError, setAccountNumberError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [accountName, setAccountName] = useState(trustData?.name);
  const [accountNameError, setAccountNameError] = useState(VALIDATION_ERROR.NO_ERROR);
  // const [fileError, setFileError] = useState(VALIDATION_ERROR.NO_ERROR)
  const [signingOfficers, setSigningOfficers] = useState(trustData?.signingOfficers ?? [""]);
  const [formCheck, setFormCheck] = useState(
    signingOfficers.length > 0 ? signingOfficers.map((x) => x?.length === 0) : [false]
  );
 
  const [showValidationError, setShowValidationError] = useState(false);

  useEffect(() => {
    financialInstitutionError === VALIDATION_ERROR.NO_ERROR &&
    branchAddressError === VALIDATION_ERROR.NO_ERROR &&
    cityError === VALIDATION_ERROR.NO_ERROR &&
    postalCodeError === VALIDATION_ERROR.NO_ERROR &&
    accountNumberError === VALIDATION_ERROR.NO_ERROR &&
    accountNameError === VALIDATION_ERROR.NO_ERROR 
      ? setShowValidationError(false)
      : setShowValidationError(true);
  }, [
    financialInstitutionError,
    branchAddressError,
    cityError,
    postalCodeError,
    accountNumberError,
    accountNameError
  ]);

  const provinceOptionElements = useMemo(() => {
    return Object.keys(CanadaProvinceList).map((key) => {
      const element = CanadaProvinceList[key];
      return (
        <option key={key} value={element}>
          {element}
        </option>
      );
    });
  }, []);

  const validateData = () => {
    const ret1 = ValidateString(financialInstitution, VALIDATION_TYPE.STRING_NON_EMPTY);
    setFinancialInstitutionError(ret1);

    const ret2 = ValidateString(branchAddress, VALIDATION_TYPE.CIVIC_ADDRESS);
    setBranchAddressError(ret2);

    const ret3 = ValidateString(city, VALIDATION_TYPE.STRING_NON_EMPTY);
    setCityError(ret3);

    const ret4 = ValidateString(GetProviceCodeFromName(province),VALIDATION_TYPE.CANADA_PROVINCE_CODE)
    setProvinceError(ret4);

    const ret5 = ValidateString(postalCode, VALIDATION_TYPE.CANADA_POSTAL_CODE);
    setPostalCodeError(ret5);

    const ret6 = ValidateString(accountNumber, VALIDATION_TYPE.STRING_NON_EMPTY);
    setAccountNumberError(ret6);

    const ret7 = ValidateString(accountName, VALIDATION_TYPE.STRING_NON_EMPTY);
    setAccountNameError(ret7);

    return (
      ret1 === VALIDATION_ERROR.NO_ERROR &&
      ret2 === VALIDATION_ERROR.NO_ERROR &&
      ret3 === VALIDATION_ERROR.NO_ERROR &&
      ret4 === VALIDATION_ERROR.NO_ERROR &&
      ret5 === VALIDATION_ERROR.NO_ERROR &&
      ret6 === VALIDATION_ERROR.NO_ERROR &&
      ret7 === VALIDATION_ERROR.NO_ERROR
    );
  };


  const handleSave = () => {
    //reset errors
    setShowValidationError(false);
    setFinancialInstitutionError(VALIDATION_ERROR.NO_ERROR);
    setBranchAddressError(VALIDATION_ERROR.NO_ERROR);
    setCityError(VALIDATION_ERROR.NO_ERROR);
    setProvinceError(VALIDATION_ERROR.NO_ERROR);
    setPostalCodeError(VALIDATION_ERROR.NO_ERROR);
    setAccountNumberError(VALIDATION_ERROR.NO_ERROR);
    setAccountNameError(VALIDATION_ERROR.NO_ERROR);

    if (!validateData()) {
      setShowValidationError(true);
      return false;
    }

    const update = {
      key: MORTGAGE_APPLICATION_PROPERTY,
      value: {
        ...trustData,
        name: accountName,
        branchName: financialInstitution,
        address: {
          city: city,
          province: province,
          singleLineAddress: branchAddress,
          postalCode: postalCode
        },
        accountNumber: accountNumber,
        signingOfficers: signingOfficers
      },
    };

    dispatch(setMortgageProperty(update))

    return true;
  }

  const handleSaveAndNext = () => {
    if (handleSave()) { 
      dispatch(saveBusinessLicenceApplicationData(
        applicationType, applicationMode))
          .then(values => {
            // On to the next item
            dispatch(
              push(
                `${ROUTE_PATH.MA_APP}${ROUTE_PATH.RENEWAL_APPLICATION_REVIEW}`
              )
            );
          })
          .catch((err) => {
            setApplicationSaveError(true);
          });
    };
  }

  const handleSaveandClose = () => {
    if(handleSave()) {
      onEditSave();
    }
  };

  const handleFinancialInstitutionChange = (e) => {
    setFinancialInstitution(e.target.value);
    setFinancialInstitutionError(VALIDATION_ERROR.NO_ERROR);
  };

  const handleBranchAddressChange = (e) => {
    setBranchAddress(e.target.value);
    setBranchAddressError(VALIDATION_ERROR.NO_ERROR);
  };

  const handleCityChange = (e) => {
    setCity(e.target.value);
    setCityError(VALIDATION_ERROR.NO_ERROR);
  };

  const handlePostalCodeChange = (e) => {
    setPostalCode(e.target.value);
    setPostalCodeError(VALIDATION_ERROR.NO_ERROR);
  };

  const handleAccountNumberChange = (e) => {
    setAccountNumber(e.target.value);
    setAccountNumberError(VALIDATION_ERROR.NO_ERROR)
  };

  const handleAccountNameChange = (e) => {
    setAccountName(e.target.value);
    setAccountNameError(VALIDATION_ERROR.NO_ERROR);
  };

  const SigningOfficerBlock = ({ data = [] , showValidationError}) => {
      return (
        <div className="row" >
        <div className="col-lg-12">
          {" "}
          <fieldset className="ns-fieldset">
            <label
              id={"trust-account-account-name-label"}
              className="ns-label"
              htmlFor={"trust-account-account-name-text"}
            >
              Signing Officers
            </label>
            {data.map((element, index) => (
              <>
                <div className="row" style={{paddingBottom: "10px"}}>
                  <div className="col-lg-6">
                      <TrustAccountSigningOfficer
                          name={element}
                          validationError={showValidationError && formCheck[index]}
                          index={index}
                          onSaveItem={(index, saveElement) => {
                              let signingOfficersUpdate = [
                              ...signingOfficers,
                              ];
                              signingOfficersUpdate[index] = saveElement;
                              setSigningOfficers(signingOfficersUpdate);
                              setShowValidationError(false);

                              // reset form check
                              let updateFormCheck = [...formCheck];
                              setFormCheck(updateFormCheck.map((x) => false));
                          }}
                      />
                  </div>
                  {(index > 0) && <div className="col-lg-4" style={isModal ? {marginLeft: "0px"} : {marginLeft: "-150px"}}>
                      <NavigationLinkButton
                          id={"branch-remove-signing-officer"}
                          text={"- Remove this officer"}
                          onClick={() => {
                              let signingOfficersUpdate = [
                                ...signingOfficers,
                              ];
                              signingOfficersUpdate.splice(index, 1);
                              setSigningOfficers(signingOfficersUpdate);
                              setShowValidationError(false);

                              let formCheckUpdate = [...formCheck];
                              formCheckUpdate.splice(index, 1);
                              setFormCheck(formCheckUpdate);
                          }}
                      />
                  </div>} 
              </div>
             </>
            ))}
          </fieldset>
        </div>
      </div>
      )
  }



  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar 
                {...props} 
                applicationType={applicationType} 
                applicationMode={APPLICATION_MODE_NEW} />
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Header
                  style={{ paddingBottom: "30px" }}
                  id="trust-account-header"
                  header="Confirm Trust Account"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Paragraph
                  style={{ paddingBottom: "30px" }}
                  id="trust-account-header"
                  text={[
                    "If your Trust Account information is out of date, you can update it before you continue your licence renewal."
                  ]}
                />
              </div>
            </div>
          </>
        )}

        {/* Financial Institution */}
        <div className="row">
          <div className="col-lg-8">
            <div
              className={
                "ns-fieldset" +
                ((financialInstitutionError !== ERROR_CODE.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
              }
            >
            <fieldset className="ns-fieldset">
              <label
                id={"trust-account-financial-institution-label"}
                className="ns-label"
                htmlFor={"trust-account-financial-institution-text"}
              >
                Financial Institution
              </label>
              {financialInstitutionError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"trust-account-financial-institution-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString(ERROR_STRING.FINANCIAL_INSTITUTE_NAME_EMPTY)}
                </span>
              )}
              <input
                type="text"
                className={
                  "fw-25" +
                  (financialInstitutionError === VALIDATION_ERROR.NO_ERROR
                    ? " ns-input"
                    : " ns-input--error")
                }
                id={"trust-account-financial-institution-text"}
                name={"trust-account-financial-institution-text"}
                value={financialInstitution}
                onChange={handleFinancialInstitutionChange}
              />
            </fieldset>
            </div>
          </div>
        </div>

        {/* Branch Address */}
        <div className="row">
          <div className="col-lg-8">
            <div
              className={
                "ns-fieldset" +
                ((branchAddressError !== ERROR_CODE.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
              }
            >
            <fieldset className="ns-fieldset">
              <label
                id={"trust-account-branch-address-label"}
                className="ns-label"
                htmlFor={"trust-account-branch-address-text"}
              >
                Branch Address
              </label>
              {branchAddressError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"trust-account-branch-address-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString(ERROR_STRING.FINANCIAL_INSTITUTE_ADDRESS_EMPTY)}
                </span>
              )}
              <input
                type="text"
                className={
                  "fw-25" +
                  (branchAddressError === VALIDATION_ERROR.NO_ERROR
                    ? " ns-input"
                    : " ns-input--error")
                }
                id={"trust-account-branch-address-text"}
                name={"trust-account-branch-address-text"}
                value={branchAddress}
                onChange={handleBranchAddressChange}
              />
            </fieldset>
            </div>
          </div>
        </div>

        {/* City */}
        <div className="row">
          <div className="col-lg-8">
            <div
              className={
                "ns-fieldset" +
                ((cityError !== ERROR_CODE.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
              }
            >
            <fieldset className="ns-fieldset">
              <label
                id={"trust-account-city-label"}
                className="ns-label"
                autoComplete="postal-code"
                htmlFor={"trust-account-city-text"}
              >
                City
              </label>
              {cityError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"trust-account-city-text-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString(ERROR_STRING.FINANCIAL_INSTITUTE_CITY_EMPTY)}
                </span>
              )}
              <input
                type="text"
                className={
                  "fw-25" +
                  (cityError === VALIDATION_ERROR.NO_ERROR
                    ? " ns-input"
                    : " ns-input--error")
                }
                id={"trust-account-city-text"}
                name={"trust-account-city-text"}
                value={city}
                onChange={handleCityChange}
              />
            </fieldset>
            </div>
          </div>
        </div>

        {/* Province Select section */}
        <div className="row">
          <div className="col-lg-8">
            <div
              className={
                "ns-fieldset" +
                ((provinceError !== VALIDATION_ERROR.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
              }
            >
              <label
                id={"trust-account-select-label"}
                className="ns-label"
                htmlFor={"trust-account-select-input"}
              >
                Province
              </label>
              {(provinceError !== VALIDATION_ERROR.NO_ERROR) && (
                <span
                  id={"trust-account-select-input-error"}
                  className="ns-error-message fieldset-validation-error"
                >
                  {ErrorWithString(ERROR_STRING.CONTACT_DETAILS_PROVINCE_EMPTY)}
                </span>
              )}
              <div className="select fw-25 inlineDisplay">
                <select
                  className={(provinceError !== VALIDATION_ERROR.NO_ERROR) ? "select--error" : ""}
                  style={{ width: "25em" }}
                  id={"trust-account-select-input"}
                  name={"trust-account-select-input"}
                  value={province ?? ""}
                  onChange={(e) => {
                    setProvince(e.target.value);
                    setProvinceError(VALIDATION_ERROR.NO_ERROR)
                  }}
                >
                  {provinceOptionElements}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Postal Code */}
        <div style={{paddingBottom: "30px"}} className="row">
          <div className="col-lg-8">
            <div
              className={
                "ns-fieldset" +
                ((postalCodeError !== VALIDATION_ERROR.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
              } 
            >
            <fieldset className="ns-fieldset">
              <label
                id={"trust-account-postal-code-label"}
                className="ns-label"
                autoComplete="postal-code"
                htmlFor={"trust-account-postal-code-text"}
              >
                Postal Code
              </label>
              {postalCodeError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"trust-account-postal-code-text-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString(postalCodeErrorString(postalCodeError))}
                </span>
              )}
              <input
                type="text"
                className={
                  "fw-25" +
                  (postalCodeError === VALIDATION_ERROR.NO_ERROR
                    ? " ns-input"
                    : " ns-input--error")
                }
                id={"trust-account-postal-code-text"}
                name={"trust-account-postal-code-text"}
                value={postalCode}
                onChange={handlePostalCodeChange}
              />
            </fieldset>
            </div>
          </div>
        </div>

        {/* Account Number */}
        <div className="row">
          <div className="col-lg-8">
            <div
              className={
                "ns-fieldset" +
                ((accountNumberError !== VALIDATION_ERROR.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
              } 
            >
            <fieldset className="ns-fieldset">
              <label
                id={"trust-account-account-number-label"}
                className="ns-label"
                htmlFor={"trust-account-account-number-text"}
              >
                Account Number
              </label>
              {accountNumberError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"trust-account-account-number-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString(ERROR_STRING.FINANCIAL_INSTITUTE_ACCOUNT_NUMBER_EMPTY)}
                </span>
              )}
              <input
                type="text"
                className={
                  "fw-25" +
                  (accountNumberError === VALIDATION_ERROR.NO_ERROR
                    ? " ns-input"
                    : " ns-input--error")
                }
                id={"trust-account-account-number-text"}
                name={"trust-account-account-number-text"}
                value={accountNumber}
                onChange={handleAccountNumberChange}
              />
            </fieldset>
            </div>
          </div>
        </div>

        {/* Account Name */}
        <div className="row">
          <div className="col-lg-8">
          <div
              className={
                "ns-fieldset" +
                ((accountNameError !== VALIDATION_ERROR.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
              } 
            >
            {" "}
            <fieldset className="ns-fieldset">
              <label
                id={"trust-account-account-name-label"}
                className="ns-label"
                htmlFor={"trust-account-account-name-text"}
              >
                Name on the account
              </label>
              {accountNameError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"trust-account-account-name-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString(ERROR_STRING.FINANCIAL_INSTITUTE_ACCOUNT_NAME_EMPTY)}
                </span>
              )}
              <input
                type="text"
                className={
                  "fw-25" +
                  (accountNameError === VALIDATION_ERROR.NO_ERROR
                    ? " ns-input"
                    : " ns-input--error")
                }
                id={"trust-account-account-name-text"}
                name={"trust-account-account-name-text"}
                value={accountName}
                onChange={handleAccountNameChange}
              />
            </fieldset>
            </div>
          </div>
        </div>

        {/* Signing Officers */}
        <SigningOfficerBlock 
          data={signingOfficers} 
          showValidationError={showValidationError} 
        />

        <div className="row bottomMarginLarge">
          <div className={"col-lg-8"}>
            <NavigationLinkButton
              id={"trust-account-add-more-link"}
              text={"+ Add another signing officer"}
              onClick={() => {
                setSigningOfficers([...signingOfficers, ""]);

                setFormCheck([...formCheck, true]);
              }}
            />
          </div>
        </div>

        {/*financial institution agreement - file*/}
        {/* <div className="row">
          <div className="col-xs-12 col-lg-8">
          <fieldset className="ns-fieldset">
              <label
                id={"trust-account-financial-document-label"}
                className="ns-label"
                htmlFor={"trust-account-financial-document-text"}
              >
                Agreement or statement from your financial institution
              </label>
              {(financialStatementFile && Object.keys(financialStatementFile).length > 0) && fileComponent()}
            </fieldset>
          </div>
        </div> */}

        {/* <div className="row">
          <div className="col-xs-12 col-lg-8">
            <div 
              className={
                "ns-fieldset" +
                ((fileError !== VALIDATION_ERROR.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
              }
            >
            <fieldset className="ns-fieldset" id="criminal-records-form">
              <div className={"ns-fieldset"}>
                <label
                  className="ns-label"
                  id="upload-financial-statement-file-label"
                  htmlFor="upload-financial-statement-file-input"
                >
                  Upload a file
                </label>
                <div className="ns-file-input">
                  <input
                    disabled={(financialStatementFile && Object.keys(financialStatementFile).length > 0)}
                    className="ns-input"
                    style={{width: "15em", display: "inline"}}
                    type="file"
                    value=""
                    accept={acceptedFileFormats(DOCUMENT_TYPE_FINANCIAL_STATEMENT_LETTER).join(',')}
                    id="upload-financial-statement-file-input"
                    name="upload-financial-statement-file-input"
                    multiple={false}
                    onInput={handleFileInput}
                  />
                </div>
              </div>
            </fieldset>
            </div>
          </div>
        </div> */}

        {/* <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Paragraph
              style={{ paddingBottom: "20px" }}
              id="upload-financial-statement"
              text={[
                "The maximum file size allowed is 15 MB per file and 50 MB total. Supported document types are Microsoft Word, Microsoft Office Excel, or Adobe PDF.  All digital files must be in an uncompressed format, i.e no zip or ARC files.",
              ]}
            />
          </div>
        </div> */}

        <div className="row">
          <div
            className={
              "col-lg-4" +
              (showValidationError || applicationSaveError ? " has-error" : "")
            }
          >
            <Button
              id="trust-account-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Continue" : "Save and close"}
              showSpinner={!applicationSaveError && (serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
              disabled={(serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
              onClick={!isModal ? handleSaveAndNext : handleSaveandClose}
            />
            {(showValidationError || applicationSaveError) && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CHECK_FIELDS}
              </div>
            )}
            {applicationSaveError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
          </div>
        </div>
        {/* <DocumentViewer 
            fileData={documentViewerDocument}
            isOpen={openDocumentViewer}
            fileName={financialStatementFile?.filename}
            handleClose={() => setOpenDocumentViewer(false)}
        /> */}
      </div>
    </>
  );
};
